import React from 'react';
import { Link } from '../link';
import classNames from 'classnames';
import { getLinkInformation } from '../../utils/functions';
import './TopHeader.scss';
import Icon from '../../atoms/icon';
import { Wrapper } from '../../utils/components';

function TopHeaderItem({
  labelItem,
  iconItem,
  iconThickness,
  checkIconItem,
  pageTitleItem,
  internalLinkItem,
  externalLinkItem,
  linkAsButton,
}) {
  const linkInformation = getLinkInformation(
    internalLinkItem,
    externalLinkItem,
    labelItem,
    pageTitleItem
  );

  return (
    <li className='top-header-list top-header-list__item'>
      <Wrapper
        className={classNames('top-header-link', {
          'top-header-link--link-as-button': linkAsButton,
        })}
        tag='span'
        component={linkInformation.link && Link}
        to={linkInformation.link}
        forceOpenToSelf
      >
        {iconItem !== '' && (
          <span
            className={classNames('top-header-svg', {
              'top-header-svg--without-margin':
                !linkInformation.label || checkIconItem,
            })}
          >
            <Icon icon={iconItem} thickness={iconThickness} />
          </span>
        )}
        {linkInformation.label && !checkIconItem && (
          <span>{linkInformation.label}</span>
        )}
      </Wrapper>
    </li>
  );
}

export default TopHeaderItem;
